
import { mapGetters } from "vuex";
import { mask } from "vue-the-mask";

export default {
  name: "GrupoEmpresaIndex",
  directives: {
    mask,
  },
  data() {
    return {
      carregando: true,
      carregandoUsuarios: false,
      salvando: false,
      cadastrandoFilial: false,
      grupo: null,
      usuarios: [],
      novoGrupoNome: "",
      formFilial: {
        nome: "",
        nome_fantasia: "",
        cnpj_cpf: "",
        responsavel: "",
        email: "",
        fone: "",
      },
      opcoesEscopo: [
        { value: "SOMENTE_EMPRESA", text: "Somente empresa de origem" },
        { value: "EMPRESAS_SELECIONADAS", text: "Empresas selecionadas" },
        { value: "TODO_GRUPO", text: "Todo o grupo" },
      ],
    };
  },
  computed: {
    ...mapGetters(["currentUser", "empresaContexto"]),
    empresaAtualId() {
      return Number(this.empresaContexto?.id_empresa || 0);
    },
    podeGerenciar() {
      return (
        Boolean(this.currentUser?.admin) &&
        Number(this.grupo?.id_empresa_matriz) === this.empresaAtualId
      );
    },
    limiteAtingido() {
      const limite = Number(this.grupo?.limite_empresas || 0);
      const utilizadas = Number(
        this.grupo?.empresas_ativas || this.grupo?.membros?.length || 0
      );

      return limite > 0 && utilizadas >= limite;
    },
    usuariosConfiguraveis() {
      return this.usuarios.filter(
        (usuario) =>
          usuario.status === "A" &&
          !(
            usuario.admin &&
            Number(usuario.id_empresa_origem) ===
              Number(this.grupo?.id_empresa_matriz)
          )
      );
    },
  },
  methods: {
    opcoesEmpresasGrupo(usuario) {
      return (this.grupo?.membros || [])
        .filter(
          (membro) =>
            membro.ativo !== false &&
            Number(membro.id_empresa) !== Number(usuario.id_empresa_origem)
        )
        .map((membro) => ({
          value: Number(membro.id_empresa),
          text: this.nomeEmpresa(membro.empresa),
        }));
    },
    nomeEmpresa(empresa) {
      return (
        empresa?.nome_fantasia ||
        empresa?.nome ||
        `Empresa ${empresa?.id_empresa}`
      );
    },
    async carregarGrupo() {
      this.carregando = true;

      try {
        const { data } = await this.$http.get("/empresa/grupos/atual");
        this.grupo = data?.data || null;

        if (this.podeGerenciar) {
          await this.carregarUsuarios();
        }
      } finally {
        this.carregando = false;
      }
    },
    async criarGrupo() {
      if (!this.novoGrupoNome || this.salvando) return;
      this.salvando = true;

      try {
        const { data } = await this.$http.post("/empresa/grupos", {
          nome: this.novoGrupoNome,
        });
        this.grupo = data.data;
        this.novoGrupoNome = "";
        this.$toast.success("Grupo empresarial criado.");
        await this.carregarUsuarios();
      } finally {
        this.salvando = false;
      }
    },
    abrirCadastroFilial() {
      this.formFilial.responsavel = this.currentUser?.nome || "";
      this.$bvModal.show("modal-cadastrar-filial");
    },
    limparFormularioFilial() {
      this.formFilial = {
        nome: "",
        nome_fantasia: "",
        cnpj_cpf: "",
        responsavel: "",
        email: "",
        fone: "",
      };
    },
    async cadastrarFilial() {
      if (
        this.cadastrandoFilial ||
        !this.formFilial.nome ||
        !this.formFilial.cnpj_cpf
      ) {
        return;
      }

      this.cadastrandoFilial = true;

      try {
        const { data } = await this.$http.post(
          `/empresa/grupos/${this.grupo.id_grupo_empresa}/filiais`,
          this.formFilial
        );
        this.grupo = data.data.grupo;
        await this.$store.dispatch("loadEmpresas");
        this.$bvModal.hide("modal-cadastrar-filial");
        this.$toast.success("Filial cadastrada e adicionada ao grupo.");
      } catch (error) {
        const message =
          error?.response?.data?.message ||
          "Não foi possível cadastrar a filial.";
        this.$toast.error(message);
      } finally {
        this.cadastrandoFilial = false;
      }
    },
    async removerEmpresa(membro) {
      const result = await this.$swal.fire({
        icon: "warning",
        title: `Remover ${this.nomeEmpresa(membro.empresa)} do grupo?`,
        text: "Os acessos herdados para esta filial serão removidos.",
        showCancelButton: true,
        confirmButtonText: "Remover",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#f64e60",
      });

      if (!result.isConfirmed) return;
      this.salvando = true;

      try {
        const { data } = await this.$http.delete(
          `/empresa/grupos/${this.grupo.id_grupo_empresa}/empresas/${membro.id_empresa}`
        );
        this.grupo = data.data;
        await this.carregarUsuarios();
        this.$toast.success("Filial removida do grupo.");
      } finally {
        this.salvando = false;
      }
    },
    async alternarStatusGrupo() {
      const novoStatus = this.grupo.status === "A" ? "I" : "A";
      this.salvando = true;

      try {
        const { data } = await this.$http.put(
          `/empresa/grupos/${this.grupo.id_grupo_empresa}`,
          { status: novoStatus }
        );
        this.grupo = data.data;
        this.$toast.success(
          novoStatus === "A" ? "Grupo ativado." : "Grupo desativado."
        );
      } finally {
        this.salvando = false;
      }
    },
    async carregarUsuarios() {
      if (!this.grupo?.id_grupo_empresa || !this.podeGerenciar) return;
      this.carregandoUsuarios = true;

      try {
        const { data } = await this.$http.get(
          `/empresa/grupos/${this.grupo.id_grupo_empresa}/usuarios`
        );
        this.usuarios = (data?.data || []).map((usuario) => ({
          ...usuario,
          empresas: (usuario.empresas || []).map(Number),
          salvando: false,
        }));
      } finally {
        this.carregandoUsuarios = false;
      }
    },
    normalizarEmpresasUsuario(usuario) {
      if (usuario.escopo_acesso !== "EMPRESAS_SELECIONADAS") {
        usuario.empresas = [];
      }
    },
    podeSalvarUsuario(usuario) {
      if (this.grupo.status !== "A" || usuario.salvando) return false;

      return (
        usuario.escopo_acesso !== "EMPRESAS_SELECIONADAS" ||
        usuario.empresas.length > 0
      );
    },
    async salvarAcessoUsuario(usuario) {
      if (!this.podeSalvarUsuario(usuario)) return;
      this.$set(usuario, "salvando", true);

      try {
        await this.$http.put(
          `/empresa/grupos/${this.grupo.id_grupo_empresa}/usuarios/${usuario.id_usuario}/acesso`,
          {
            id_empresa_origem: usuario.id_empresa_origem,
            escopo_acesso: usuario.escopo_acesso,
            empresas: usuario.empresas,
          }
        );
        this.$toast.success(`Acesso de ${usuario.nome} atualizado.`);
      } finally {
        this.$set(usuario, "salvando", false);
      }
    },
  },
  mounted() {
    this.carregarGrupo();
  },
};
